import { Stack, TextField } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GET_BOXES } from "../../../../enums/ApiPaths";
import useSubmit from "../../../master/species/hooks/useSubmit";
import DialogCore from "../core/DialogCore";
import { formatPet } from "./AddPetToBox";
import BoxPetSelector from "./components/BoxPetSelector";
import { GlobalDataContext } from "../../../../contexts/GlobalData";
import { VIEW_STATIONARY } from "../../../../enums/PermissionTitles";
import { useContext } from "react";

export default function AddBox({ color = "primary", fullWidth = false }) {
  const methods = useForm();
  const { t } = useTranslation();
  const id = null;
  const url = "/saps/box/add/new";
  const key = GET_BOXES;
  const invalidateQueries = [key];
  const submittion = useSubmit(id, url, key, invalidateQueries);
  const { isPermissionAllowed } = useContext(GlobalDataContext);
  const noPermission = !isPermissionAllowed(VIEW_STATIONARY);
  function submitData(data) {
    if (noPermission) return null;

    const pet = data?.pet ? data?.pet : null;
    var formattedPet = null;

    if (pet) {
      formattedPet = formatPet(pet, data);
    }

    var submitData = {
      name: data?.name,
      pet: formattedPet,
    };

    if (data.user) {
      submitData = {
        ...submitData, 
        userData: data.user.userDetails,
      };
    }

    submittion.submitCallback(submitData);

    if (submittion.success) {
      methods.reset();
    }
  }

  if (noPermission) {
    return null;
  }

  return (
    <FormProvider {...methods}>
      <form id="add-box-form" onSubmit={methods.handleSubmit(submitData)}>
        <DialogCore
          closeWhen={submittion.success}
          buttonFullWidth={fullWidth}
          color={color}
          disabled={!methods.watch("name") || noPermission}
          formId="add-box-form" //This is needed for the submit button to work
          buttonTitle={t("AddBox")}
          maxWidth="lg"
          title={t("AddNewBox")}
          isLoading={submittion.loading}
        >
          <Stack spacing={3} mt={2}>
            <TextField
              id="title-input"
              label={`${t("BoxName")} *`}
              variant="outlined"
              key="name"
              inputProps={{ maxLength: 120 }}
              {...methods.register("name")}
            />
            <BoxPetSelector showUserSelector={true} />
          </Stack>
        </DialogCore>
      </form>
    </FormProvider>
  );
}

export function BoxBorder({ children }) {
  return (
    <Stack
      border={`1px solid #2f2f2fff`}
      borderRadius={"8px"}
      padding={2}
      spacing={2}
    >
      {children}
    </Stack>
  );
}
